// utils/formStatePersistence.js
export const FORM_STORAGE_KEY = 'app_draft_data';

export const saveToLocalStorage = (data) => {
  sessionStorage.setItem(FORM_STORAGE_KEY, JSON.stringify(data));
};

export const loadFromLocalStorage = () => {
  const raw = sessionStorage.getItem(FORM_STORAGE_KEY);
  try {
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
};

export const clearLocalStorage = () => {
  sessionStorage.removeItem(FORM_STORAGE_KEY);
};
